module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAICAYAAABatbkrAAAAAXNSR0IArs4c6QAAAFdJREFUSEtj/NXG8J8BD2CrYmDEJ/+zjWEzPnn2KgZfvPpbGRrw6q/GL/+jBb/5HDX43fe1gUEKn/2MowE0GkB4U/hoChrNYqNlEN5CfLSQHq3FBnc1DwBjjmyBs65tCwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/notice_logo.png
// module id = 342
// module chunks = 0